type useDownloadFromBlobReturnType = (data: string, filename: string, blobPropertyBag?: BlobPropertyBag) => void

export const useDownloadFromBlob = (): useDownloadFromBlobReturnType => {
  const downloadFromBlob = (data: string, filename: string, blobPropertyBag?: BlobPropertyBag): void => {
    const url = window.URL.createObjectURL(new Blob([data], blobPropertyBag))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', createFileName(filename))
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  const createFileName = (filename: string) => {
    const whitelist = 'abcdefghijklmnopqrstuvxyzoäöåABCDEFGHIJKLMNOPQRSTUVXYZOÄÖ1234567890-'
    var newString = ''

    const filenameArray = [...filename]

    filenameArray.forEach((character) => {
      if (whitelist.includes(character)) {
        newString += character
      }
    })

    return newString.toLowerCase().trim()
  }

  return downloadFromBlob
}
